import type { MouseEvent } from 'react';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import useOpenGame from '../../../hooks/useOpenGame';
import type { HGPokerGameTile } from '../../../types/common';

interface Props {
  className?: string;
  unsupported?: boolean;
  encodedEndpoint?: string;
  tableUrl?: string;
  link: HGPokerGameTile['link'];
  id: HGPokerGameTile['id'];
  clubId: HGPokerGameTile['clubId'];
}

const Wrapper: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  className,
  unsupported,
  clubId,
  id,
  link,
  tableUrl
}) => {
  const isEmbedded = useSelector(select.device.isEmbedded);
  const openGame = useOpenGame({ unsupported, clubId, id, link, tableUrl });

  const handleOnGameClicked = (e: MouseEvent<HTMLAnchorElement | HTMLDivElement>) => {
    e?.preventDefault();
    openGame(e);
  };

  return !isEmbedded && !unsupported ? (
    <a href={tableUrl} className={className} onClick={handleOnGameClicked} data-testid="game-item">
      {children}
    </a>
  ) : (
    <div data-testid="game-item" className={className} onClick={handleOnGameClicked}>
      {children}
    </div>
  );
};

export default Wrapper;
